/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AssetManagementDataHistoryItemListResponse } from '../../models/asset-management-data-history-item-list-response';
import { BaseResponse } from '../../models/base-response';

export interface AssetManagementControllerFindAllAssetManagementDataHistory$Params {
  id: number;

/**
 * Sends 0 to remove limit
 */
  limit: number;
  skip: number;
  notes?: string;
  serial_number?: string;
  asset_code?: string;
  inventory_code?: string;
  lost?: boolean;
  related_user_id?: number;
  created_on_from?: string;
  created_on_to?: string;
  order_by?: string;
  order_direction?: string;
}

export function assetManagementControllerFindAllAssetManagementDataHistory(http: HttpClient, rootUrl: string, params: AssetManagementControllerFindAllAssetManagementDataHistory$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AssetManagementDataHistoryItemListResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, assetManagementControllerFindAllAssetManagementDataHistory.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
    rb.query('notes', params.notes, {});
    rb.query('serial_number', params.serial_number, {});
    rb.query('asset_code', params.asset_code, {});
    rb.query('inventory_code', params.inventory_code, {});
    rb.query('lost', params.lost, {});
    rb.query('related_user_id', params.related_user_id, {});
    rb.query('created_on_from', params.created_on_from, {});
    rb.query('created_on_to', params.created_on_to, {});
    rb.query('order_by', params.order_by, {});
    rb.query('order_direction', params.order_direction, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: AssetManagementDataHistoryItemListResponse;
      }>;
    })
  );
}

assetManagementControllerFindAllAssetManagementDataHistory.PATH = '/asset-management/{id}/data-history';
